import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router= new Router({
  // mode: 'history',
  base: __dirname,
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: '/',
      redirect: {
        name: 'vegetablesIndex'  //vegetablesIndex,要想打开测试的模拟导航页面就改为index,项目修改完后打包项目就改回vegetablesIndex
      }
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/pages/index'], resolve),
    },
    {
      path: '/vegetables/index',
      name: 'vegetablesIndex',
      meta: {
        name: 'vegetables'
      },
      component: resolve => require(['@/pages/vegetablesIndex'], resolve),
    },
    {
      path: '/vegetables/detail',
      name: 'vegetablesDetail',
      meta: {
        name: 'detail'
      },
      component: resolve => require(['@/pages/vegetablesDetail'], resolve),
    },
    {
      path: '/vegetables/order',
      name: 'vegetablesOrder',
      meta: {
        name: 'order',
      },
      component: resolve => require(['@/pages/vegetablesOrder'], resolve),
    },
    {
      path: '/cuponList/:type',
      name: 'cuponList',
      component: resolve => require(['@/pages/cuponList'], resolve),
    },
    {
      path: '/goodsAddress',
      name: 'goodsAddress',
      component: resolve => require(['@/pages/goodsAddress'], resolve),
    },
    {
      path: '/selectTime',
      name: 'selectTime',
      component: resolve => require(['@/pages/selectTime'], resolve),
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      meta: {
        name: 'searchPage',
      },
      component: resolve => require(['@/pages/searchPage'], resolve),
    },
    {
      path: '/foodSelfTakeTimeList',
      name: 'foodSelfTakeTimeList',
      meta: {
        name: 'foodSelfTakeTimeList',
      },
      component: resolve => require(['@/pages/foodSelfTakeTimeList'], resolve),
    },
    {
      path: '/add',
      name: 'add',
      component: resolve => require(['@/pages/add'], resolve),
    },
    { //更多体验店页面
      path: '/GourmetShops/:lat/:log/:regionId',
      name: 'GourmetShops',
      component: resolve => require(['@/pages/GourmetShops'], resolve),
    },
    {
      path: '/addMenu',
      name: 'addMenu',
      component: resolve => require(['@/pages/addMenu'], resolve),
    },
    { //美食体验首页
      path: '/nearbyfoods',
      name: 'nearbyfoods',
      meta: {
        name: 'foods'
      },
      component: resolve => require(['@/pages/nearbyfoods'], resolve),
    },
    // 用户信息
    {
      path: '/userinfo',
      name: 'userinfo',
      component: resolve => require(['@/pages/mine/home/userInfo'], resolve),
    },
    // 粮票1
    {
      path: '/balance',
      name: 'balance',
      component: resolve => require(['@/pages/mine/home/balance'], resolve),
    },
    // 粮票
    {
      path: '/balancedetail',
      name: 'balancedetail',
      component: resolve => require(['@/pages/mine/home/balanceDetail'], resolve),
    },
    // 优惠券 红包
    {
      path: '/card',
      name: 'card',
      component: resolve => require(['@/pages/mine/home/card'], resolve),
    },
    // 优惠券领取中心
    {
      path: '/cardcenter',
      redirect: '/cardcenter/0'
    },
    {
      path: '/cardcenter/:type',
      name: 'cardcenter',
      component: resolve => require(['@/pages/mine/home/cardCenter'], resolve),
    },
    // 消息中心
    {
      path: '/news',
      name: 'news',
      component: resolve => require(['@/pages/mine/home/news'], resolve),
    },
    // 客服中心
    {
      path: '/costomcenter',
      name: 'costomcenter',
      component: resolve => require(['@/pages/mine/home/costomCenter'], resolve),
    },
    // 我的订单
    {
      path: '/order',
      name: 'order',
      component: resolve => require(['@/pages/mine/home/order'], resolve),
    },
    // 订单明细
    {
      path: '/orderdetail',
      redirect: '/orderdetail/791'
    },
    {
      path: '/orderdetail/:orderId',
      name: 'orderdetail',
      component: resolve => require(['@/pages/mine/home/orderDetail'], resolve),
    },
    // 地址管理
    {
      path: '/address',
      name: 'address',
      component: resolve => require(['@/pages/mine/home/address'], resolve),
    },
    // 新增地址重定向
    {
      path: '/addressedit',
      redirect: '/addressedit/add'
    },
    // 新增、编辑地址
    {
      path: '/addressedit/:mode',
      name: 'addressedit',
      component: resolve => require(['@/pages/mine/home/addressEdit'], resolve),
    },
    {
      path: '/collect',
      name: 'collect',
      meta: {
        name: 'collect'
      },
      component: resolve => require(['@/pages/mine/home/collect'], resolve),
    },
    //在线充值
    {
      path: '/onlineRecharge',
      name: 'onlineRecharge',
      component: resolve => require(['@/pages/mine/home/onlineRecharge'], resolve),
    },
    { //底部bar的（第三个）我来煮首页
      path: '/purchased',
      name: 'purchased',
      component: resolve => require(['@/pages/purchased'], resolve),
    },
    {
      path: '/news1',
      name: 'news1',
      component: resolve => require(['@/pages/news'], resolve),
    },
    //分享页
    {
      path: '/sharePage',
      name: 'sharePage',
      component: resolve => require(['@/pages/sharePage'], resolve),
    },

    /***
     * 再来一单
     * 订单详情页
     * 优惠券
     * ****/
    {
      path: '/addList',
      name: 'AddList',
      component: resolve => require(['@/pages/addList/order'], resolve),
    },
    {
      path: '/addList/couponList',
      name: 'AddCouponList',
      component: resolve => require(['@/pages/addList/couponList'], resolve),
    },
    {
      path: '/selfshoplist',
      name: 'Selfshoplist',
      component: resolve => require(['@/pages/addList/selfShopList'], resolve),
    },
    //用户协议
    {
      path: '/msg',
      name: 'Msg',
      component: resolve => require(['@/pages/msg'], resolve),
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['@/pages/test'], resolve),
    },
    {
      // 功能开发中
      path: '*',
      name: '404',
      meta: {
        title: '404 功能建设中',
      },
      component: resolve => require(['@/pages/building'], resolve),
    },
  ]
})

router.beforeEach((to, from, next) => {
  
  var str=window.location.hash;
  if(str){
    var hash=str.substr(1);
		var newStr=hash.split("?")[0]
		if(newStr.indexOf("=")!=-1){
			var searchStr=hash.split("?")[0]
			var length=searchStr.split("/").length
			var hashName=searchStr.split("/")[length-1]
			var url=""
		    var arr=hash.split("\/"+hashName+'?')
		    for(var i=0;i<arr.length;i++){
		    	url+=arr[i]
		    	
		    }
        if(url.indexOf('/')!=-1){
         url=url.substr(1);
        }
        
		var newUrl=window.location.protocol+"//"+window.location.host+"/#/"+hashName+"?"+url
   
    window.location.href=newUrl
    window.event.returnValue = false

		}else{
            
        next()

    }

  }else{
    next()
  }
		
		
			

 















})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js